import React from 'react';

import Card from '@components/Card';
import Modal from '@shared/Modal';
import Spinner from '@shared/Spinner';
import Button from '@shared/Button';

import {
  ModalContainer,
  SummarySection,
  ErrorItem,
  ErrorRuleName,
  ErrorDetail,
  CloseButtonRow,
  DiffSummary,
  ValidationErrors,
  RawJsonView,
} from './RuleDiffShared';

export default function PreviewDiffModal({ response, isLoading, error, handleClose }) {
  const hasValidationErrors =
    response && response.status === 'validation_failed' && response.errors;
  const hasDiff =
    response && response.status === 'validation_passed' && response.diff;

  let title = 'Rule Change Preview';
  if (hasValidationErrors) {
    title = 'Rule Change Preview — Validation Failed';
  }

  return (
    <Modal id='preview-diff-modal' open toggle={handleClose} closeOnClickOutside maxWidth={900}>
      <Card title={title} shadow>
        <ModalContainer>
          {isLoading && <Spinner center />}

          {error && (
            <SummarySection>
              <ErrorItem>
                <ErrorRuleName>Request Error</ErrorRuleName>
                <ErrorDetail>{error}</ErrorDetail>
              </ErrorItem>
            </SummarySection>
          )}

          {hasValidationErrors && (
            <ValidationErrors errors={response.errors} />
          )}

          {hasDiff && (
            <>
              <DiffSummary
                diff={response.diff}
                emptyMessage='No rule changes detected. The uploaded rules match the current configuration.'
              />
              <RawJsonView src={response.diff} />
            </>
          )}

          <CloseButtonRow>
            <Button onClick={handleClose}>Close</Button>
          </CloseButtonRow>
        </ModalContainer>
      </Card>
    </Modal>
  );
}
